module.exports = __webpack_public_path__ + "img/comfort-car.422a4258.svg";